import  "./workCards.css";

import React from 'react'
// import { NavLink} from "react-router-dom";

function WorkCard(props) {
  return (
    <div className="project-card">
    <img src={props.imgsrc} alt ="propic" />
    <h2 className="project-title">{props.title} </h2>
    <div className="pro-details">
        <p>{props.text}</p>
        <div className ="pro-btns">
        <a href={props.view} className="btn">Views</a>
        <a href="https://github.com/hritik8795?tab=repositories" className="btn">Github</a>

        </div>
    </div>
    </div>
  )
}

export default WorkCard